<div class="datetime-picker-container">
  <div class="datetime-input" (click)="openModal()">
    <span [class.placeholder]="!value">{{ formatDisplayValue(value) }}</span>
    <ion-icon name="calendar-outline" class="calendar-icon"></ion-icon>
  </div>

  <ion-modal [isOpen]="isOpen" (didDismiss)="confirmSelection()">
    <ng-template>
      <div class="modal-container">
        <div class="modal-header">
          <h2>Selecionar Data e Horário</h2>
          <ion-button fill="clear" (click)="cancelSelection()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </div>

        <div class="modal-content">
          <ion-datetime
            mode="ios"
            hourCycle="h23"
            [(ngModel)]="selectedDateTime"
            [min]="minDateValue"
            [max]="maxDate"
            presentation="date-time"
            [prefer-wheel]="true"
            [show-default-buttons]="false"
            [show-clear-button]="false"
            [show-default-title]="false"
            [show-default-time-label]="false"
            [hourValues]="hourValues"
            (ionChange)="onDateTimeChange($event)">
            <span slot="time-label">Horário</span>
          </ion-datetime>

          <div class="datetime-buttons">
            <app-button [styles]="buttonStyles.secondaryButton" [dots]="false"
              [text]="'CANCELAR'" (action)="cancelSelection()"></app-button>
            <app-button [styles]="buttonStyles.primaryButton" [dots]="false"
              [text]="'CONFIRMAR'" (action)="confirmSelection()"></app-button>
          </div>
        </div>
      </div>
    </ng-template>
  </ion-modal>
</div>
